import React from "react";
import { connect } from "react-redux";

import { Loader } from "../../../../../core/atoms/loader";
import { apiPromiseHook, createEnterHookPromise } from "../../../../../shared/flux/actions/enterHooks";
import { MatchState } from "../../../../../shared/helpers/reduxHelpers";
import { HtmlRenderBlock } from '../../../../../core/atoms';
import SharedActionPromises from "../../../../../shared/state/actionPromises";

import "./bookingTerms.scss";

type Props = ReturnType<typeof stateToProps>

class CustomerEnquiryBookingTerms extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render = () => {
    const { bookingTerms } = this.props;

    return (
      <div className="booking-terms width-wrapper p-top-medium p-bottom-medium">
        {MatchState(bookingTerms, {
          none: () => <Loader />,
          data: ({ termsHtml }) => <HtmlRenderBlock htmlString={termsHtml} />,
        })}
      </div>
    )
  }
}

const stateToProps = (state: ISharedStoreState) => {
  return {
    bookingTerms: state.customerEnquiryTerms,
  };
};

export const BookingTerms = connect(stateToProps)(CustomerEnquiryBookingTerms);

export const bookingTermsOnEnter = apiPromiseHook(
  createEnterHookPromise((n) => SharedActionPromises.getEnquiryTerms(parseInt(n.params.enquiryId))),
);
